module.exports = __webpack_public_path__ + "static/img/partner-cimc.2d5ad43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-cimc.png
// module id = qw0F
// module chunks = 34